module.exports = __webpack_public_path__ + "static/media/process-improve.1a91df01.svg";